<div style="text-align: -webkit-center;padding: 20px;display: flex;align-items: center;justify-content: center;">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>